/**
 * Loading spinner component for async operations
 */
import { Loader2 } from "lucide-react"
import { cn } from "@/lib"

interface LoadingSpinnerProps {
  className?: string;
  fullPage?: boolean;
}

export const LoadingSpinner = ({ className, fullPage = false }: LoadingSpinnerProps) => {
  if (fullPage) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <Loader2 className={cn("h-10 w-10 animate-spin text-primary", className)} />
      </div>
    );
  }

  return (
    <Loader2 className={cn("h-8 w-8 animate-spin text-primary", className)} />
  );
};
